<template>
  <div :class="{ 'center-screen' : !isMobile }">
    <div class="container">
      <div class="auth-page">
        <div class="form">
          <div class="row">
            <div class="col col-12">
                <div class="content">
                  <h3 class="line-title">Şifremi Unuttum</h3>
                  <form class="auth-content" v-on:submit.prevent="onSubmit">
                    <div class="col">
                        <div class="inline-form">
                          <label>Kayıtlı Olan e-mail adresiniz</label>
                          <input type="email" v-model="form.email" placeholder="E-mail'inizi yazınız">
                        </div>
                    </div>
                    <div class="col justify-flex-end">
                        <ButtonLoader class="primary" :loader="isLoading" :text="'Yeni Şifre Gönder'" >
                          <template name="icon">
                            <svg x="0px" y="0px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve"><polygon points="437.3,30 202.7,339.3 64,200.7 0,264.7 213.3,478 512,94 "></polygon></svg>
                          </template>
                        </ButtonLoader>
                    </div>
                  </form>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default{
    name: 'Password',
    metaInfo () {
        return {
        title: 'Şifremi Unuttum | ' + _.get(this.$store.getters['getClientMeta'], 'main.title', ''),
        }
    },
    data(){
      return{
        form:{
          email:null,
        },
        isLoading: false,
      }
    },
    methods:{
      onSubmit(){
        this.isLoading = true;
        axios.post('/auth/remember/password', { ...this.form })
            .then((response)=>{
              if(response.data.status){
                this.form.email = null;
                this.$store.dispatch('alert/message', { type: 'success', msg: response.data.message })
              }
          })
          .catch((err)=>{
              
          })
          .finally((f) => { 
              this.isLoading = false;
          })
      },
    },
  }
</script>